import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { config, msg } from 'api';
import { getOfferDetailsCanonicalLink } from 'apps/catalogue/links';
import getDefaultOfferDetailsPageTitle
  from '[theme-lib]/apps/catalogue/components/meta/getDefaultOfferDetailsPageTitle';

export default class OfferDetailsPageMetadata extends PureComponent {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    pageParameters: PropTypes.shape({
      id: PropTypes.string.isRequired,
      shortDescription: PropTypes.string.isRequired,
    }).isRequired,
  };

  get title() {
    return getDefaultOfferDetailsPageTitle(this.props.pageParameters);
  }

  get alternate() {
    const { pageParameters: { id } } = this.props;
    return `/promotion?promoId=${id}`;
  }

  get meta() {
    const meta = [];

    if (config.appLinksEnabled && config.iosAppId) {
      meta.push({
        name: 'apple-itunes-app',
        content: `app-id=${config.iosAppId},app-argument=${this.alternate}`,
      });
    }

    if (this.props.pageParameters.shortDescription) {
      meta.push({
        name: 'description',
        content: msg.metaData.getCatalogueDescription(this.props.pageParameters.shortDescription),
      });
    }

    // Keywords are default for offer details

    return meta;
  }

  get links() {
    const { alternate } = this;
    const { basePath, pageParameters } = this.props;
    const canonical = getOfferDetailsCanonicalLink(pageParameters, basePath);

    const links = [
      {
        rel: 'canonical',
        href: `https://${config.domain}${canonical}`,
      },
    ];

    if (config.appLinksEnabled && config.androidAppId) {
      links.push({
        rel: 'alternate',
        href: `android-app://${config.androidAppId}/https/${config.domain}${alternate}`,
      });
    }

    if (config.appLinksEnabled && config.iosAppId) {
      links.push({
        rel: 'alternate',
        href: `ios-app://${config.iosAppId}/https/${config.domain}${alternate}`,
      });
    }
    return links;
  }

  render() {
    return (
      <Helmet
        title={this.title}
        meta={this.meta}
        link={this.links}
      />
    );
  }
}
